module.exports = __webpack_public_path__ + "static/media/Adam_Carpenter_Resume_04-2024.30777dd8.pdf";